var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "22",
      "height": "22"
    }
  }, _vm.$listeners), [_c('path', {
    attrs: {
      "fill": "#FFF",
      "fill-rule": "evenodd",
      "d": "M11 14.014c-3.504 0-10.5 1.758-10.5 5.25v2.625h21v-2.625c0-3.492-6.996-5.25-10.5-5.25m0-2.625c2.9 0 5.25-2.35 5.25-5.25S13.9.889 11 .889s-5.25 2.349-5.25 5.25 2.35 5.25 5.25 5.25"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }